var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 14 13.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43927C",
    strokeWidth: 14,
    d: "M.703 13.983a.7.7 0 01-.496-1.195L12.789.206a.702.702 0 01.993.992L1.199 13.78a.7.7 0 01-.496.203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#43927C",
    strokeWidth: 14,
    d: "M13.284 13.983a.7.7 0 01-.496-.203L.206 1.198a.702.702 0 01.992-.992L13.78 12.788a.698.698 0 01-.496 1.195z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.69ccfb4272d5d1b22bb29739ae01120e.svg";
export { ForwardRef as ReactComponent };